import script from "./_Comment.vue?vue&type=script&setup=true&lang=js"
export * from "./_Comment.vue?vue&type=script&setup=true&lang=js"

import "./_Comment.vue?vue&type=style&index=0&id=3a420340&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a420340"]])

export default __exports__